"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaParamsAvaNotaUpdate = exports.yupParamsAvaNotaUpdate = exports.schemaAvaNota = exports.yupAvaNota = void 0;
const yup = __importStar(require("yup"));
exports.yupAvaNota = yup.object({
    idCurso: yup.number().positive().required().integer().label('Curso'),
    idSerie: yup.number().positive().required().integer().label('Série'),
    idTurma: yup.number().positive().required().integer().label('Turma'),
    idMateria: yup.number().positive().required().integer().label('Matéria'),
    idAluno: yup.number().positive().required().integer().label('Aluno'),
    codAluno: yup.string().required().default('').label('Código do aluno'),
    nrChamada: yup.string().required().default('').label('Número da chamada'),
    idAvaliacao: yup.number().positive().required().integer().label('Avaliação'),
    codAvaliacao: yup.string().required().default('').label('Código da avaliação'),
    bimestre: yup.number().positive().required().min(1).max(4).label('Etapa'),
    nota: yup.string().notRequired().nullable().default(null).label('Nota do aluno'),
    notaSubstitutiva: yup.string().notRequired().nullable().default(null).label('Nota da substitutiva'),
    codigoSubstitutiva: yup.string().notRequired().nullable().default(null).label('Código da avaliação da substitutiva'),
    idAvaliacaoSubstitutiva: yup.number().notRequired().nullable().default(null).label('ID da avaliação da substitutiva'),
});
exports.schemaAvaNota = exports.yupAvaNota.shape({});
exports.yupParamsAvaNotaUpdate = yup
    .object({
    id: yup.number().required().positive().integer().label('ID da nota'),
})
    .concat(exports.yupAvaNota.pick(['nota']));
exports.schemaParamsAvaNotaUpdate = exports.yupParamsAvaNotaUpdate.shape({});
